import React, { useEffect, useState } from "react";
import { MenuSelect } from "../components/Form";
import { TbMail, TbUser } from "react-icons/tb";
import { AiOutlinePoweroff } from "react-icons/ai";
import { MdOutlineNotificationsNone } from "react-icons/md";
import NotificationComp from "../components/NotificationComp";
import { useNavigate } from "react-router-dom";
import { BiMenu } from "react-icons/bi";
import MenuDrawer from "../components/Drawer/MenuDrawer";
import { setUser } from "../redux/features/userSlice";
import { useDispatch, useSelector } from "react-redux";
import bookingApi from "../api/booking/BookingApi";
import staffApi from "../api/staff/staff.api";
import userApi from "../api/user/user.api";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import { MdOutlineChatBubbleOutline } from "react-icons/md";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { MessageCircle } from "lucide-react";

function Header({ toggleSidebar, isSidebarOpen, toggleChat }) {
  const [isOpen, setIsOpen] = React.useState(false);
  const { user } = useSelector((state) => state.user);
  // console.log({ user });

  // toggle drawer
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [bookings, setBookings] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          { response: bookingsRes },
          { response: staffRes },
          { response: usersRes },
        ] = await Promise.all([
          bookingApi.getAllBookings(),
          staffApi.getAllStaffInfo(),
          userApi.getAllUsers(),
        ]);

        if (bookingsRes?.data?.booking) setBookings(bookingsRes.data.booking);
        if (staffRes?.data?.data) setStaffs(staffRes.data.data);
        if (usersRes?.data) setCustomers(usersRes.data);

        generateNotifications(bookingsRes.data.booking, usersRes.data);
      } catch (error) {
        toast.error("Something went wrong!");
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const generateNotifications = (bookings, customers) => {
    const today = dayjs().startOf("day");
    const notifs = [];

    // Optional: birthdays
    customers.forEach((customer) => {
      if (
        customer.birthday &&
        dayjs(customer.birthday).format("MM-DD") === dayjs().format("MM-DD")
      ) {
        notifs.push({
          id: `birthday-${customer._id}`,
          action: 1,
          user: { title: customer.name },
          time: dayjs().format("hh:mm A"),
          read: false,
        });
      }
    });

    // ✅ All bookings from today into the future
    bookings.forEach((booking) => {
      const bookingDate = dayjs(booking.selectedDateTime);

      if (bookingDate.isSame(today, "day") || bookingDate.isAfter(today)) {
        notifs.push({
          _id: booking._id,
          action: 2,
          user: { title: booking.customer_info?.name || "Customer" },
          time: bookingDate.format("dddd, MMM D • hh:mm A"),
          sortTime: bookingDate.toISOString(),
          read: false,
        });
      }
    });

    // Sort by time ascending
    notifs.sort(
      (a, b) => new Date(a.sortTime || a.time) - new Date(b.sortTime || b.time)
    );

    setNotifications(notifs);
  };

  // console.log({ notifications });

  // console.log({ bookings });

  // console.log({ customers });

  const DropDown1 = [
    {
      title: "Profile",
      icon: TbUser,
      onClick: () => {
        navigate("/settings");
      },
    },
    {
      title: "Inbox",
      icon: TbMail,
      onClick: () => navigate("/userInbox"),
    },
    {
      title: "Logout",
      icon: AiOutlinePoweroff,
      onClick: () => {
        dispatch(setUser(null)); // or dispatch(logoutUser()) if you have a logout action
        navigate("/");
      },
    },
  ];

  return (
    <>
      <div
        className={`fixed top-0 z-40 w-full bg-drylight bg-opacity-95  px-0 xs:px-8 grid md:grid-cols-2 grid-cols-12 items-center transition-all duration-300 ${
          isSidebarOpen ? "xl:max-w-[calc(100%-100px)] ml-0" : "ml-0 w-full"
        }`}
      >
        {" "}
        <div className="md:col-span-1 sm:col-span-11 col-span-10 flex gap-4 items-center md:py-0 py-3">
          {/* Desktop Menu Icon */}
          <button
            onClick={toggleSidebar}
            className="hidden xl:flex items-center justify-center border border-redlight w-12 h-12 rounded-md text-redlight text-2xl transition hover:bg-yellowdark"
            title="Toggle Sidebar"
          >
            <BiMenu />
          </button>

          {/* search */}
          <MenuSelect datas={DropDown1}>
            <div className="flex gap-4 items-center pl-5 rounded-lg lg:p-4 ">
              <img
                src={user?.photo}
                alt="user"
                className="w-9 lg:w-12 border-0 lg:border-1 border-border object-cover h-9 lg:h-12 rounded-full "
              />
              <div className="flex flex-col items-start">
                <p className="text-text hidden sm:block">Welcome</p>
                <div className="flex flex-col items-start lg:flex-row lg:items-center lg:gap-2">
                  <h1 className="text-redlight text-sm font-bold line-clamp-2 xs:line-clamp-1 lg:max-w-[200px] max-w-full text-left">
                    {user?.name}
                  </h1>
                  <h1 className="text-text text-[12px]">{user?.town}</h1>
                </div>
              </div>
            </div>
          </MenuSelect>
        </div>
        <div className="flex justify-end items-center gap-x-2">
          {/* <NotificationComp datas={notifications}>
              <div className="relative">
                <MdOutlineNotificationsNone className="text-2xl hover:text-subMain text-textGray" />
                {notifications.filter((n) => !n.read).length > 0 && (
                  <span className="absolute -top-2.5 -right-2.5 font-semibold bg-subMain rounded-full px-1.5 py-0.5 text-xs text-white text-center">
                    {notifications.filter((n) => !n.read).length}
                  </span>
                )}
              </div>
            </NotificationComp> */}
          <div className="relative cursor-pointer group" onClick={toggleChat}>
            <MessageCircle className="w-6 h-6 text-redlight group-hover:scale-110 transition duration-300" />
          </div>
          {/* Mobile Menu Icon */}
          <button
            onClick={toggleSidebar}
            className="block xl:hidden text-2xl bg-border w-14 ml-2 md:w-12 h-12 rounded-md flex-colo text-redlight transitions"
            title="Open Sidebar"
          >
            <HiOutlineMenuAlt3 />
          </button>
        </div>
      </div>
    </>
  );
}

export default Header;
